import api from './api'

// Типы

export interface Exercise {
  name: string
  sets?: string
  reps?: string
  weight?: string
  rest?: string
  notes?: string
}

export interface TrainingPlan {
  id: string
  trainer_id: string
  client_id: string
  title: string
  description?: string
  exercises?: Exercise[]
  image_data?: string
  status: 'active' | 'inactive'
  created_at: string
  updated_at: string
  trainer_name?: string
}

export interface CreatePlanData {
  client_id: string
  title: string
  description?: string
  exercises?: Exercise[]
  image_data?: string
}

export interface UpdatePlanData {
  title?: string
  description?: string
  exercises?: Exercise[]
  image_data?: string
}

export interface TrainingPlanListResponse {
  plans: TrainingPlan[]
  total: number
}

// API для тренера

export async function createTrainingPlan(data: CreatePlanData): Promise<TrainingPlan> {
  const response = await api.post<TrainingPlan>('/training-plans', data)
  return response.data
}

export async function getClientPlans(
  clientId: string,
  status?: 'active' | 'inactive' | 'all'
): Promise<TrainingPlanListResponse> {
  const params = status ? { status } : {}
  const response = await api.get<TrainingPlanListResponse>(
    `/training-plans/client/${clientId}`,
    { params }
  )
  return response.data
}

export async function updateTrainingPlan(
  planId: string,
  data: UpdatePlanData
): Promise<TrainingPlan> {
  const response = await api.patch<TrainingPlan>(`/training-plans/${planId}`, data)
  return response.data
}

export async function updatePlanStatus(
  planId: string,
  status: 'active' | 'inactive'
): Promise<TrainingPlan> {
  const response = await api.patch<TrainingPlan>(`/training-plans/${planId}/status`, {
    status,
  })
  return response.data
}

export async function deleteTrainingPlan(planId: string): Promise<void> {
  await api.delete(`/training-plans/${planId}`)
}

// API для клиента

export async function getMyTrainingPlans(
  trainerId?: string,
  includeImage: boolean = true
): Promise<TrainingPlanListResponse> {
  const params: Record<string, string | boolean> = { include_image: includeImage }
  if (trainerId) params.trainer_id = trainerId

  const response = await api.get<TrainingPlanListResponse>('/clients/me/training-plans', {
    params,
  })
  return response.data
}

// Утилиты

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })
}
